import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Center, Spinner, Stack, Text } from "@chakra-ui/react";

import { RoutesMap } from "../../routes.tsx";
import { useAddCardMutation } from "../../api/cards";
import { SessionStorageKeys } from "../../constants";
import { PageHeader } from "../../components/shared/PageHeader";

export function AddCardPaymentPage() {
  const navigate = useNavigate();
  const { mutateAsync } = useAddCardMutation();

  const abortController = useRef(new AbortController());
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const isProcessed = sessionStorage.getItem(SessionStorageKeys.addPaymentMethodProcessed) === "true";
    if (isProcessed) {
      navigate(RoutesMap.cards.index, { replace: true });
      return;
    }

    sessionStorage.setItem(SessionStorageKeys.addPaymentMethodProcessed, "true");

    void (async () => {
      try {
        const response = await mutateAsync({
          signal: abortController.current.signal },
        );

        if (!response.redirectUrl) {
          throw new Error("Redirect url not found");
        }

        window.location.href = response.redirectUrl;
      } catch (err: unknown) {
        console.error(err);
        setIsError(true);
      }
    }
    )();

    return () => {
      abortController.current.abort();
    };
  }, [navigate]);

  useEffect(() => {
    const handlePageShow = (e: PageTransitionEvent) => {
      if (e.persisted) {
        const isProcessed = sessionStorage.getItem(SessionStorageKeys.addPaymentMethodProcessed) === "true";
        if (isProcessed) {
          navigate(RoutesMap.cards.index, { replace: true });
        }
      }
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [navigate]);

  if (isError) {
    return (
      <Stack minH="100svh">
        <PageHeader title="Добавление карты" link={RoutesMap.cards.index} />

        <Center flex="1" pb="100px">
          <Text variant="brand" textAlign="center">
            Не удалось получить ссылку для добавления нового способа оплаты
          </Text>
        </Center>
      </Stack>
    );
  }

  return (
    <Center minH="100svh">
      <Spinner variant="purple" />
    </Center>
  );
}
